import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';

/** Kezdőlap: mi vár teendőre. Minden szám kattintható – a megfelelő listára visz. */
@Component({
  selector: 'app-ikt-attekintes',
  templateUrl: './attekintes.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktAttekintesComponent implements OnInit {
  adat: any = null;
  hiba = '';
  ev = new Date().getFullYear();

  constructor(private ikt: IktatgatoService, private router: Router) {}

  async ngOnInit() {
    try { this.adat = await this.ikt.attekintes(this.ev); }
    catch (e: any) { this.hiba = e?.error?.error || 'Az áttekintés most nem kérdezhető le.'; }
  }

  nyit(ut: string) { this.router.navigateByUrl(ut); }
}
